import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import TotalDisbursementPageUI from './TotalDisbursementPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class TotalDisbursementPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      accountDisbursedRList: null,
      accountDisbursedNRList: null,
      stateTotalOutstandingMap: null,
      response: null,
      checked: false,
      checkedAccount: true,
      onDownloadAumReportRequested: false,
    }
  }

  render() {
    return (
      <TotalDisbursementPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountDisbursedRList={this.state.accountDisbursedRList}
        accountDisbursedNRList={this.state.accountDisbursedNRList}
        stateTotalOutstandingMap={this.state.stateTotalOutstandingMap}
        response={this.state.response}
        checked={this.state.checked}
        checkedAccount={this.state.checkedAccount}
        onShowDetailsChange={this.onShowDetailsChange}
        onShowAccountDetailsChange={this.onShowAccountDetailsChange}
        onDownloadAumReport={this.onDownloadAumReport}
        onDownloadAumReportRequested={this.state.onDownloadAumReportRequested}
        onRefreshClick={this.onRefreshClick}
        onTypeChange={this.onTypeChange}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getDisbursements(context, context.filter)
  }

  getDisbursements(context, stp) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/loans/disbursements`,
      cacheKey: CacheKeys.Disbursements2(stp),
      callback: this.getDisbursementsCallback,
      ttlInSecs: 60
    })
    cacheManager.getObject2(context, {}, { stp: stp === 'stp' ? true : false })
  }

  getDisbursementsCallback = (response) => {
    let accountDisbursedRList = response.accountDisbursedList.filter(d => d.retailLoan)
    let accountDisbursedNRList = response.accountDisbursedList.filter(d => !d.retailLoan)
    this.setState({
      errorList: response.errorList,
      accountDisbursedRList: accountDisbursedRList,
      accountDisbursedNRList: accountDisbursedNRList,
      stateTotalOutstandingMap: response.stateTotalOutstandingMap,
      response: response
    })
  }

  onDownloadAumReport = () => {
    let context = this.props.context
    this.setState({ onDownloadAumReportRequested: true })
    RestApiUtils.get(context, `/api/su/accounts/loans/disbursements/excel/2/fileDownloadSignedUrl`,
      this.getAumReportCallback, {}, { stp: context.filter === 'stp' ? true : false })
  }

  getAumReportCallback = (response) => {
    this.setState({ onDownloadAumReportRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onShowDetailsChange = () => {
    let newChecked = !this.state.checked
    CacheManager.setObject(CacheKeys.Disbursements2(this.props.context.filter), { checked: newChecked })
    this.setState({
      checked: newChecked
    })
  }

  onShowAccountDetailsChange = () => {
    let newChecked = !this.state.checkedAccount
    CacheManager.setObject(CacheKeys.Disbursements2(this.props.context.filter), { checkedAccount: newChecked })
    this.setState({
      checkedAccount: newChecked
    })
  }

  onTypeChange = (type) => {
    let context = this.props.context
    this.getDisbursements(context, type)
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.Disbursements2(this.props.context.filter))
    this.setState({ accountDisbursedNList: null, accountDisbursedNRList: null, stateTotalOutstandingMap: null, errorList: null }, () => {
      this.getDisbursements(this.props.context, this.props.context.filter)
    })
  }

}

export default withRouter(TotalDisbursementPageSF)
